export const exportSpeedManagmentToExcelService =
  (fetchData) => async (filters) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetchData({
        url: "/api/v1/gestion-velocidad/export/excel?" + searchParams,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error exporting speed management data:", error);
    }
  };
